import React from 'react';
import { useEffect, useState } from "react";
import CLOSE from '../../images/2723639.png';
import Order from './Order';

const OrdersSearch = (
  {currentOrders,
   updateOrder, 
   handleCurrentOrders, 
   employees, 
   handleCurrentemployees, 
   handleSearch
  }) => {
  const [previousOrders, setPreviousOrders] = useState('');
  const [number, setNumber] = useState('');


  useEffect(() => {
    if (sessionStorage.previousOrders) {
      setPreviousOrders(
        JSON.parse(sessionStorage.previousOrders)
      )
    }
   }, [])
  
  return (
    <section className="fixed-container">
    <div className='fixed-con fixed-con-search'>
    <div className="orders-search-container">
    <div className='close' onClick={() => handleSearch()}>
      <img src={CLOSE} alt='close' />
    </div>
      <h1>Search</h1>
      <br />
      <input 
        type='search' 
        placeholder="0123-456-7890"
        value={number}
        onChange={(e) => setNumber(e.target.value)}  
      />
      {/0[0-9]{10}/.test(number) && 
      <>
        {currentOrders.length > 0 && 
        <>
        <h2 style={{color: 'lightgray'}}>Today</h2>
        {currentOrders.filter((order) => order.value.phone === number).map((order) => (
          <Order 
          key={order.id} 
          order={order}
          updateOrder={updateOrder}
          handleCurrentOrders={handleCurrentOrders}
          employees={employees}
          handleCurrentemployees={handleCurrentemployees}
        />))}
        </>
        }

        {previousOrders &&
        <>
        <h2 style={{color: 'lightgray'}}>Previous " Last 7 days "</h2>
        {previousOrders.filter((order) => order.value.phone === number).map((order, index) => (
          <div key={order.id + '' + index} className='order-con previous'>
            <div className={`order s ${order.state}`}>
              <p>{new Date(order.date).toDateString()}</p>
              <div className='value'>
                <div className='order-counter'>
                  <p>{order.counter}</p>
                </div>
                <p className='choose-em'>{
                  order.employee ? order.employee : ""
                }</p>
                <p className='phone-num'>{order.value.phone}</p>
                <p className='order-text'>
                  {order.value.text}
                </p>
              </div>
            </div>
            <p className='order-time'>{order.time}</p>    
          </div>
        ))}
        </>
        }
      </>
      }

    </div>
    </div>
    </section>
  )
}

export default OrdersSearch;